import React, { FC } from 'react'
import {
    Button,
    Modal,
    ModalBody as Body,
    ModalFooter as Footer,
    ModalHeader as Header,
    ModalTitle as Title,
} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export type ConflictReason = 'changed_by_other' | 'locked_by_other' | 'not_loaded'

export interface ConflictResponse {
    error: string
    reason: ConflictReason
    stateToken: string
}

const COPY: {[reason in ConflictReason]: string} = {
    changed_by_other: 'app.bimboShareForm.conflict.changedByOther',
    locked_by_other: 'app.bimboShareForm.conflict.lockedByOther',
    not_loaded: 'app.bimboShareForm.conflict.notLoaded',
}

const BimboShareConflictModal: FC<{
    show: boolean
    reason?: ConflictReason
    onReload: () => void
    onOverwrite: () => void
    onCancel: () => void
}> = ({ show, reason, onReload, onOverwrite, onCancel }) => {
    const { t } = useTranslation()

    return (
        <Modal show={show} onHide={onCancel} backdrop="static" keyboard={false} centered>
            <Header closeButton>
                <Title>{t('app.bimboShareForm.conflict.title')}</Title>
            </Header>
            <Body>
                <p>
                    {t(COPY[reason ?? 'changed_by_other'])}
                </p>
                <p className="text-muted mb-0">{t('app.bimboShareForm.conflict.reloadWarning')}</p>
            </Body>
            <Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {t('app.cancel')}
                </Button>
                {/*
                  * Overriding a share that never loaded is the data loss this dialog exists to stop, and
                  * overriding somebody who is holding the share open is what the lock exists to stop.
                  */}
                {'changed_by_other' === reason && (
                    <Button variant="outline-danger" onClick={onOverwrite}>
                        {t('app.bimboShareForm.conflict.overwrite')}
                    </Button>
                )}
                <Button variant="outline-primary" onClick={onReload}>
                    {t('app.bimboShareForm.conflict.reload')}
                </Button>
            </Footer>
        </Modal>
    )
}

export default BimboShareConflictModal
